import { authServiceApi } from "../authServiceApi";
import { employeeServiceApi } from "../employeeServiceApi";

import { Middleware } from "@reduxjs/toolkit";
import { setShowModal } from "../../features/auth/authSlice";
import { payrollServiceApi } from "../payrollServiceApi";
import { visitServiceApi } from "../visitServiceApi";

export const cacheInvalidationMiddleware: Middleware =
  (store) => (next) => (action) => {
    // complete profile cash remove
    
    if (
      (authServiceApi.endpoints as any)?.updateCompleteProfile?.matchFulfilled(
        action
      )
    ) {
      const { id } = action.meta.arg;

      store.dispatch(
        employeeServiceApi.util.invalidateTags([
          { type: "GetEmployees" },
          { type: "GetEmployeeDetails", id },
        ])
      );
    }

    // update visit setting cash remove
    if (
      (visitServiceApi.endpoints as any)?.updateVisitSetting?.matchFulfilled(
        action
      )
    ) {
      const id = action?.meta?.arg?.originalArgs?.data?.id;

      store.dispatch(
        employeeServiceApi.util.invalidateTags([
          { type: "GetBusinessData", id },
        ])
      );
    }

    // update profile cash remove
    if (
      (authServiceApi.endpoints as any)?.profileUpdate?.matchFulfilled(action)
    ) {
      const id = action?.meta?.arg?.originalArgs?.data?.business_member_id;

      store.dispatch(
        employeeServiceApi.util.invalidateTags([
          { type: "GetEmployees" },
          { type: "GetEmployeeDetails", id },
        ])
      );
    }

    // update company profile cash remove
    if (
      (authServiceApi.endpoints as any)?.companyProfileUpdate?.matchFulfilled(
        action
      )
    ) {
      const id = action?.meta?.arg?.originalArgs?.data?.business_id;

      store.dispatch(
        employeeServiceApi.util.invalidateTags([
          { type: "GetBusinessData", id },
        ])
      );
    }

    // update salary cash remove
    if (
      (payrollServiceApi.endpoints as any)?.updateSalaryDetails?.matchFulfilled(
        action
      )
    ) {
      store.dispatch(employeeServiceApi.util.invalidateTags(["GetEmployees"]));
    }

    return next(action);
  };

export const invalidateAllTagsOnSignInMiddleware =
  (apis: any[]) => (store: any) => (next: any) => (action: any) => {
    if (action.type === "auth/userLoggedIn") {
      apis.forEach((api) => {
        store.dispatch(api?.util?.resetApiState());
        store.dispatch(setShowModal(true));
      });
    }
    return next(action);
  };
